import { render } from "./Service.vue?vue&type=template&id=6518d527&scoped=true"
import script from "./Service.vue?vue&type=script&lang=ts"
export * from "./Service.vue?vue&type=script&lang=ts"

import "./Service.vue?vue&type=style&index=0&id=6518d527&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6518d527"

export default script